<template>
  <div>

    <div class="d-flex justify-space-between mb-5">
      <div>
        <div class="page-title mb-2">
          รายงานความก้าวหน้าที่ยื่น สป.อว.
        </div>
        <div class="d-flex align-center font-type-bold txt-head black--text">
          <Iconify
              icon="ci:list-checklist"
              color="var(--theme-color-one)"
              class="mr-3"
          ></Iconify>
          รายงานความก้าวหน้าที่ยื่น สป.อว
        </div>
      </div>

      <div class="d-flex flex-column gap-12">
        <div class="d-flex gap-12">
<!--          <div class="flex-center" style="max-width: 190px">-->
<!--            <div class="min-width-max">สถานะ</div>-->
<!--            <SelectBox-->
<!--                placeholder="สถานะ"-->
<!--                hide-details-->
<!--            ></SelectBox>-->
<!--          </div>-->

          <div style="max-width: 250px">
            <TextField
                hide-details
                placeholder="ค้นหา"
                append-inner-icon="search"
                @onChange="searchData.keyword = $event"
                @onEnter="getFormAList()"
            ></TextField>
          </div>
        </div>

      </div>
    </div>

    <div>
      <div class="d-flex justify-space-between table-head">
        <div
            v-for="(item, i) in tableHeader"
            :key="i"
            :style="{ 'width': item.width }"
        >
          {{ item.name }}
        </div>
      </div>

      <div class="list-layout">
        <ProgressReportOfferItem
            v-for="(item, i) in formAList"
            :key="i"
            :item="item"
            :index="i"
            :headers="tableHeader"
        ></ProgressReportOfferItem>
      </div>
    </div>

    <v-pagination
        class="mt-6"
        v-model="paginate.current_page"
        :length="paginate.last_page"
        color="#DE7033"
        @input="getFormAList"
    ></v-pagination>

  </div>
</template>

<script>
import TextField from "../../components/input/TextField"
import Button from "../../components/input/Button"
import SelectBox from "../../components/input/SelectBox"
import ProgressReportOfferItem from "../../components/ProgressReportOfferItem"

export default {
  name: "ProgressReportOfferList",
  components: {
    TextField,
    SelectBox,
    ProgressReportOfferItem,
    Button
  },
  data () {
    return {
      tableHeader: [
        {
          name: '',
          width: '8%'
        },
        {
          name: 'ลำดับ',
          width: '6%'
        },
        {
          name: 'ปี งปม.',
          width: '8%'
        },
        {
          name: 'ชื่อโครงการหลัก',
          width: '39%'
        },
        {
          name: 'ผู้นำเข้าข้อมูล',
          width: '10%'
        },
        {
          name: 'วัน-เวลาที่สร้าง',
          width: '13%'
        },
        {
          name: 'ระยะเวลา',
          width: '8%'
        },
        {
          name: 'สถานะ',
          width: '8%'
        }
      ],
      formAList: [],
      searchData: {
        keyword: null
      },
      paginate: {
        total: 1,
        per_page: 1,
        current_page: 1,
        last_page: 1,
      },
    }
  },
  created () {
    this.getFormAList()
  },
  methods: {
    createProject () {
      this.$router.push({ name: 'MainProjectForm' })
    },
    async getFormAList (page) {
      let res
      let payload = {
        page: page,
        keyword: this.searchData.keyword,
        doc_type: 'Progress,Final'
      };

      res = await this.$apiFire('AForm/getFormAList',payload)
      console.log(res)
      this.formAList = res.data.map((item, index) => {
        return {
          ...item,
          no: (res.current_page - 1) * res.per_page + index + 1
        }
      });
      this.paginate = {
        total: res.total,
        per_page: res.per_page,
        current_page: res.current_page,
        last_page: res.last_page,
      };
    }
  }
}
</script>

<style scoped>
.table-head {
  padding: 0 33px 0 36px;
  margin-bottom: 12px;
  gap: 8px;
}

.list-layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>